import React, { useState, useEffect } from "react";
import Logo from "../../images/Avanse-Education-Loans-Logo.png";
import { MenuUnfoldOutlined } from "@ant-design/icons";
import { Col, Row, Nav } from "react-bootstrap";
import { Drawer, Popover, notification } from "antd";
import { NavLink as Link } from "react-router-dom";

import PartnerLogo from "../../images/Partner-Managment.png";
import LeadLogo from "../../images/Lead-Management.png";
import ApplicationLogo from "../../images/Application.png";
import deleteIcon from "../../images/delet-branch.png";
import BranchDetails from "../../images/BranchDetails.png";
import Documents from "../../images/Documents.png";
import Human from "../../images/human1.png";
import ChangePassword from "../../containers/Pages/Login/ChangePassword";
import Logout from "../../containers/Pages/Login/Logout";
import {
  getTeamSideBarDetails,
  getSideBarBranch,
} from "../../redux/SideBarTeams/action";
import lock from "../../images/lock.png";
import { connect } from "react-redux";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import BackArrow from "../../images/back-arrow.png";
import { saveDeletBrachIdDetails } from "../../redux/DeleteBranchName/action";
import { saveDeletTeamsIdDetails } from "../../redux/DeleteTeamsDetails/action";
import { Button, message, Modal } from "antd";
import { GetBranchCountDetails } from "../../redux/BranchCount/action";
import useSession from "../CustomLogout/useSession";

function PartnerMobileHeader(props) {
  const handleSessionExpired = useSession();

  const [mobileMenu, setMobileMenu] = React.useState(false);
  const [open, setOpen] = useState(false);
  const hide = () => {
    setOpen(false);
  };
  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };

  const [engagementDetailsList, setEngagementDetailsList] = useState(true);
  const [firmDetailsList, setirmDetailsList] = useState(false);
  const [branchDetailsList, setBranchdetailsList] = useState(false);
  const [teamsDetailsList, setTeamsdetailsList] = useState(false);
  const [teamCount, setTeamCount] = useState(0);
  const [branchCount, setBranchCount] = useState(0);

  const [Branch, setBranch] = useState(
    useSelector((state) => state.teamSideBar)
  );

  const [teamDetails, setTeamDetails] = useState(
    useSelector((state) => state.teamSideBar)
  );

  let navigate = useNavigate();

  let NavigateBranch = (e, BranchId, id) => {
    navigate(`/PartnerDashBoard/branchdetails`, {
      state: {
        id,
        BranchId,
      },
    });
  };

  let Navigate = (e, teamId, id) => {
    navigate(`/PartnerDashBoard/teamdetails`, {
      state: { teamId, id },
    });
  };

  useEffect(() => {
    setBranch(props?.data.branchDetails);
    setTeamDetails(
      props?.data?.sidebarTeamsDetails?.PARTNER_TEAM_PERSON_MASTER
    );
    props?.data?.sidebarTeamsDetails?.count !== undefined
      ? setTeamCount(props?.data?.sidebarTeamsDetails?.count)
      : setTeamCount(0);
    setBranchCount(props?.BranchCount?.count);
  }, [props?.data]);

  const handleMobileMenu = () => {
    setMobileMenu(!mobileMenu);
  };

  const onClose = () => {
    setMobileMenu(false);
  };

  const hideDetails = () => {
    setEngagementDetailsList(true);
    setirmDetailsList(false);
    setBranchdetailsList(false);
    setTeamsdetailsList(false);
  };
  const hideFirmDetails = () => {
    setEngagementDetailsList(false);
    setirmDetailsList(true);
    setBranchdetailsList(false);
    setTeamsdetailsList(false);
  };
  const hideBranchDetails = () => {
    setEngagementDetailsList(false);
    setirmDetailsList(false);
    setBranchdetailsList(true);
    setTeamsdetailsList(false);
  };
  const hideTeamsDetails = () => {
    setEngagementDetailsList(false);
    setirmDetailsList(false);
    setBranchdetailsList(false);
    setTeamsdetailsList(true);
  };

  const Id = sessionStorage.getItem("cetFirmId");
  const partnerSidebarDtoList =
    props?.partnerSidebarDtoList?.length > 0
      ? props?.partnerSidebarDtoList
      : [];

  const EngagementDetailStatus =
    partnerSidebarDtoList?.find((item) => item.page === "EngagementDetails")
      ?.status === "COMPLETE"
      ? true
      : false;

  const FirmDetailStatus =
    partnerSidebarDtoList?.find((item) => item.page === "FirmDetails")
      ?.status === "COMPLETE"
      ? true
      : false;
  const BranchDetailStatus =
    partnerSidebarDtoList?.find((item) => item.page === "BranchDetails")
      ?.status === "COMPLETE"
      ? true
      : false;
  const TeamDetailStatus =
    partnerSidebarDtoList?.find((item) => item.page === "TeamDetails")
      ?.status === "COMPLETE"
      ? true
      : false;

  const DocumentStatus =
    partnerSidebarDtoList?.find((item) => item.page === "Documents")?.status ===
    "COMPLETE"
      ? true
      : false;

  const loggedInRoleType = props.userData?.loggedInRoleType ?? "";

  const checkRM = loggedInRoleType === "RM";

  const handleDeleteChanges = (id, firmId) => {
    const partnerFirmId = firmId;
    const partnerBranchId = id;
    props
      .saveDeletBrachIdDetails({
        access_token: props.access_token,
        partnerFirmId: partnerFirmId,
        partnerBranchId: partnerBranchId,
      })
      .then((res) => {
        if (res && res.status === 200) {
          message.success("Branch Deleted Successfully");
          props.GetBranchCountDetails({
            access_token: props.access_token,
            partnerFirmId: partnerFirmId,
          });
          props
            .getBranchData({
              accessToken: props.access_token,
              partnerFirmId: partnerFirmId,
            })
            .then((res) => {
              if (res?.data?.error || res.message) {
                const errorCode = res?.data?.error?.errorCode || res.errorCode;
                const errorMessage = res?.data?.error?.message || res.message;

                if (errorCode === "403" && res?.data?.error?.logoutStatus) {
                  handleSessionExpired();
                } else {
                  notification.error({
                    description: errorMessage,
                    duration: 5,
                    placement: "top",
                  });
                }
              }
            });
          hideBranchDetails();
          setIsModalVisible(false);
        }
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      });
  };

  const handleDeleteChangesTeams = (teamId, id) => {
    const partnerFirmId = id;
    const partnerTeamId = teamId;
    props
      .saveDeletTeamsIdDetails({
        access_token: props.access_token,
        partnerFirmId: partnerFirmId,
        partnerTeamId: partnerTeamId,
      })
      .then((res) => {
        if (res && res.status === 200) {
          message.success("Team Deleted Successfully");
          props.getTeamsData({
            accessToken: props.access_token,
            partnerFirmID: partnerFirmId,
          });
          hideTeamsDetails();
          setModalTeamsDetele(false);
        }
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      });
  };

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalTeamsDetele, setModalTeamsDetele] = useState(false);

  const showTeamsModel = () => {
    setModalTeamsDetele(true);
  };
  const ModelTeamsCancel = () => {
    setModalTeamsDetele(false);
  };
  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  const adminFirstName = (adminName) => {
    if (adminName) return adminName?.toUpperCase()?.charAt(0);
    else return null;
  };

  const adminLastName = (adminLast) => {
    if (adminLast) return adminLast?.toUpperCase()?.charAt(0);
    else return null;
  };

  return (
    <div className="cet-mobile-header">
      <Row className="side-br-mob">
        <Col xs={2}>
          <button
            className="hamburger-icon"
            type="primary"
            onClick={handleMobileMenu}
          >
            <MenuUnfoldOutlined />
          </button>
        </Col>
        <Col xs={7}>
          <div className="log-avs">
            <img src={Logo} alt="" width={100} height={40} />
          </div>
        </Col>
        <Col xs={3} className="cet-mobile-header-login">
          <div className="login-profie">
            <div className="img-sec">
              <Popover
                color={"white"}
                content={
                  <div>
                    <h4>{props.userDetail?.userName}</h4>
                    <h5 className="mb-3">{props.userDetail?.roleName}</h5>
                    <ChangePassword hide={hide} />
                    <Logout hide={hide} />
                  </div>
                }
                placement="bottomRight"
                trigger="click"
                open={open}
                onOpenChange={handleOpenChange}
              >
                <div className="img-sec-mobile">
                  <h2>
                    {adminFirstName(
                      props.userDetail?.firstName ??
                        props.userDetail?.userName?.split(" ")[0]?.trim()
                    )}
                  </h2>
                  <h2>
                    {adminLastName(
                      props.userDetail?.lastName ??
                        props.userDetail?.userName?.split(" ")[1]?.trim()
                    )}
                  </h2>
                </div>
                {/* <img className="iconLog" src={AdminProfile} alt="" /> */}
              </Popover>
            </div>
          </div>
        </Col>
      </Row>
      <Drawer
        open={mobileMenu}
        onClose={onClose}
        placement="left"
        width={300}
        className="cet-mobile-header-drawer"
      >
        <div className="log-avs">
          <img src={Logo} alt="" />
        </div>
        <div className="list-contnt">
          <ul className="list">
            <li className="" onClick={onClose}>
              <Link
                onClick={hideDetails}
                className="ListItem"
                to="/PartnerDashBoard/EngagementDetails"
              >
                <img src={PartnerLogo} alt="" className="sidebarIcon" />
                <span className="list-Text">Engagement Details</span>
              </Link>
            </li>

            {engagementDetailsList ? (
              <ul className="inner-list">
                <li className="text-inner-list" onClick={onClose}>
                  <Nav.Link
                    activeclassname="active"
                    href="/PartnerDashBoard/EngagementDetails#EngagmentType"
                    className="navigation__link"
                  >
                    Engagement Type
                  </Nav.Link>
                </li>

                <li className="text-inner-list" onClick={onClose}>
                  <Nav.Link
                    activeclassname="active"
                    href="/PartnerDashBoard/EngagementDetails#EngagmentRole"
                    className="navigation__link"
                  >
                    Role With Avanse
                  </Nav.Link>
                </li>
                <li className="text-inner-list" onClick={onClose}>
                  <Nav.Link
                    activeclassname="active"
                    href="/PartnerDashBoard/EngagementDetails#EngagmentProduct"
                    className="navigation__link"
                  >
                    Products Interested
                  </Nav.Link>
                </li>
              </ul>
            ) : null}

            {EngagementDetailStatus ? (
              <>
                <li onClick={onClose}>
                  <Link
                    onClick={hideFirmDetails}
                    className="ListItem"
                    to="/PartnerDashBoard/FirmDetails"
                  >
                    <img src={LeadLogo} alt="" className="sidebarIcon" />
                    <span className="list-Text">Firm Details</span>
                  </Link>
                </li>
                {firmDetailsList ? (
                  <ul className="inner-list">
                    <Nav.Link
                      activeclassname="active"
                      href="/PartnerDashBoard/FirmDetails#Constitution"
                      className="navigation__link"
                      onClick={onClose}
                    >
                      <li className="text-inner-list">Firm Constitution</li>
                    </Nav.Link>
                    <Nav.Link
                      activeclassname="active"
                      href="/PartnerDashBoard/FirmDetails#PanVerification"
                      className="navigation__link"
                      onClick={onClose}
                    >
                      <li className="text-inner-list">PAN Verification</li>
                    </Nav.Link>
                    <Nav.Link
                      activeclassname="active"
                      href="/PartnerDashBoard/FirmDetails#FirmDetails"
                      className="navigation__link"
                      onClick={onClose}
                    >
                      <li className="text-inner-list">Firm Details</li>
                    </Nav.Link>
                    <Nav.Link
                      activeclassname="active"
                      href="/PartnerDashBoard/FirmDetails#HeadOffice"
                      className="navigation__link"
                      onClick={onClose}
                    >
                      <li className="text-inner-list">Head Office Details</li>
                    </Nav.Link>
                    <Nav.Link
                      activeclassname="active"
                      href="/PartnerDashBoard/FirmDetails#BankDetails"
                      className="navigation__link"
                      onClick={onClose}
                    >
                      <li className="text-inner-list">Bank Details</li>
                    </Nav.Link>
                  </ul>
                ) : null}
              </>
            ) : (
              <li onClick={onClose}>
                <div className="btn-seclast">
                  <div className="lock-sidebar">
                    <img src={LeadLogo} alt="" className="sidebarIcon" />
                    <span className="list-Text">Firm Details</span>
                  </div>
                  <div className="lock-sidebar-img">
                    <img src={lock} alt="" />
                  </div>
                </div>
              </li>
            )}

            {EngagementDetailStatus && FirmDetailStatus ? (
              <>
                <li onClick={onClose}>
                  <Link
                    onClick={hideBranchDetails}
                    className="ListItem"
                    to="/PartnerDashBoard/branchdetailsfornew"
                  >
                    <img src={BranchDetails} alt="" className="sidebarIcon" />
                    <div className="cbfcc">
                      <span className="list-Text">Branch Details</span>
                      <div className="fsfsfaf">{branchCount}</div>
                    </div>
                  </Link>
                </li>
                {branchDetailsList && Branch?.length > 0 ? (
                  <>
                    <ul>
                      <li className="text-inner-list-btn">
                        <Link
                          to="/PartnerDashBoard/branchdetailsfornew"
                          className="addNewTeams"
                          onClick={onClose}
                        >
                          <span className="list-Text">ADD NEW BRANCH</span>
                        </Link>
                      </li>
                    </ul>
                    <ul className="inner-list  inner-Scroll-list">
                      {Branch?.map((el) => {
                        return (
                          <li className="text-inner-list">
                            <div className="side-menu-slider">
                              <div className="img-del">
                                {/* <Tooltip title="prompt text"> */}{" "}
                                <img
                                  src={deleteIcon}
                                  alt=""
                                  onClick={showModal}
                                />
                              </div>
                              <Modal
                                open={isModalVisible}
                                closable={false}
                                className="modal-container"
                                centered
                                footer={null}
                              >
                                <Row className="mt-4">
                                  <Col lg={12} xs={12} md={12} sm={12}>
                                    <p>
                                      Are you sure you want to delete Branch?
                                    </p>
                                  </Col>
                                </Row>

                                <Row className="mt-4">
                                  <Col
                                    md={12}
                                    className="d-flex justify-content-end mt-4"
                                  >
                                    <Button
                                      className="mr-3"
                                      htmlType="button"
                                      type="default"
                                      onClick={handleCancel}
                                    >
                                      No
                                    </Button>
                                    <Button
                                      onClick={() => {
                                        handleDeleteChanges(
                                          el?.partnerBranchId,
                                          el?.partnerFirmId
                                        );
                                        onClose();
                                      }}
                                      className=""
                                      type="primary"
                                    >
                                      Yes
                                    </Button>
                                  </Col>
                                </Row>
                              </Modal>
                              <div
                                className="text-sec"
                                onClick={(e) => {
                                  NavigateBranch(
                                    e,
                                    el?.partnerBranchId,
                                    el?.partnerFirmId
                                  );
                                  onClose();
                                }}
                              >
                                {el?.partnerBranchLocationAddress?.cityName +
                                  " " +
                                  el?.partnerBranchLocationAddress?.pincode}
                              </div>
                            </div>
                          </li>
                        );
                      })}
                    </ul>
                  </>
                ) : null}
              </>
            ) : (
              <li>
                <div className="btn-seclast">
                  <div className="lock-sidebar">
                    <img src={BranchDetails} alt="" className="sidebarIcon" />

                    <span className="list-Text">Branch Details</span>
                  </div>
                  <div className="lock-sidebar-img">
                    <img src={lock} alt="" />
                  </div>
                </div>
              </li>
            )}

            {EngagementDetailStatus &&
            FirmDetailStatus &&
            BranchDetailStatus ? (
              <>
                <li>
                  <Link
                    onClick={() => {
                      hideTeamsDetails();
                      onClose();
                    }}
                    className="ListItem"
                    to="/PartnerDashBoard/teamdetailsfornew"
                  >
                    <img src={ApplicationLogo} alt="" className="sidebarIcon" />
                    <div className="cbfcc">
                      <span className="list-Text">Team Details</span>
                      <div className="fsfsfa">{teamCount}</div>
                    </div>
                  </Link>
                </li>
                {teamsDetailsList ? (
                  <>
                    <ul>
                      <li className="text-inner-list-btn">
                        <Link
                          className="addNewTeams"
                          to="/PartnerDashBoard/teamdetailsfornew"
                          onClick={onClose}
                        >
                          <span className="list-Text">ADD NEW TAEM</span>
                        </Link>
                      </li>{" "}
                    </ul>
                    <ul className="inner-list inner-Scroll-list">
                      {teamDetails?.map((el) => {
                        return (
                          <li className="text-inner-list">
                            <div className="side-menu-slider">
                              <div className="img-del">
                                {/* <Tooltip title="prompt text"> */}{" "}
                                <img
                                  src={deleteIcon}
                                  alt=""
                                  onClick={showTeamsModel}
                                />
                                <Modal
                                  open={modalTeamsDetele}
                                  closable={false}
                                  className="modal-container"
                                  centered
                                  footer={null}
                                >
                                  <Row className="mt-4">
                                    <Col lg={12} xs={12} md={12} sm={12}>
                                      <p>
                                        Are you sure you want to delete Team
                                        Person?
                                      </p>
                                    </Col>
                                  </Row>

                                  <Row className="mt-4">
                                    <Col
                                      md={12}
                                      className="d-flex justify-content-end mt-4"
                                    >
                                      <Button
                                        className="mr-3"
                                        htmlType="button"
                                        type="default"
                                        onClick={ModelTeamsCancel}
                                      >
                                        No
                                      </Button>
                                      <Button
                                        onClick={() => {
                                          handleDeleteChangesTeams(
                                            el?.partnerPersonId,
                                            el?.partnerFirmId
                                          );
                                          onClose();
                                        }}
                                        className=""
                                        type="primary"
                                      >
                                        Yes
                                      </Button>
                                    </Col>
                                  </Row>
                                </Modal>
                                {/* </Tooltip> */}
                              </div>
                              <div
                                className="text-sec"
                                onClick={(e) => {
                                  Navigate(
                                    e,
                                    el?.partnerPersonId,
                                    el?.partnerFirmId
                                  );
                                  onClose();
                                }}
                              >
                                {el?.personFullName}
                              </div>
                            </div>
                          </li>
                        );
                      })}
                    </ul>
                  </>
                ) : null}
              </>
            ) : (
              <li>
                <div className="btn-seclast">
                  <div className="lock-sidebar">
                    <img src={ApplicationLogo} alt="" className="sidebarIcon" />
                    <span className="list-Text">Team Details</span>
                  </div>
                  <div className="lock-sidebar-img">
                    <img src={lock} alt="" />
                  </div>
                </div>
              </li>
            )}

            <li onClick={onClose}>
              {EngagementDetailStatus &&
              FirmDetailStatus &&
              BranchDetailStatus &&
              TeamDetailStatus ? (
                <>
                  {!checkRM ? (
                    <Link className="ListItem" to="/partnerdashboard/user">
                      <img src={Human} alt="" className="sidebarIcon" />
                      <span className="list-Text">User Details</span>
                    </Link>
                  ) : (
                    ""
                  )}
                </>
              ) : (
                <>
                  {!checkRM ? (
                    <div className="btn-seclast">
                      <div className="lock-sidebar">
                        <img src={Human} alt="" className="sidebarIcon" />
                        <span className="list-Text">User Details</span>
                      </div>

                      <div className="lock-sidebar-img">
                        <img src={lock} alt="" />
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </>
              )}
            </li>

            <li onClick={onClose}>
              {EngagementDetailStatus &&
              FirmDetailStatus &&
              BranchDetailStatus &&
              TeamDetailStatus ? (
                <>
                  <Link className="ListItem" to="/partnerdashboard/document">
                    <img src={Documents} alt="" className="sidebarIcon" />
                    <span className="list-Text">Documents</span>
                  </Link>
                </>
              ) : (
                <div className="btn-seclast">
                  <div className="lock-sidebar">
                    <img src={Documents} alt="" className="sidebarIcon" />
                    <span className="list-Text">Documents</span>
                  </div>

                  <div className="lock-sidebar-img">
                    <img src={lock} alt="" />
                  </div>
                </div>
              )}
            </li>
          </ul>
        </div>
        <div className="list-contnt">
          {loggedInRoleType === "RM" && (
            <ul className="list">
              <li className="">
                <Link
                  className="ListItem"
                  to={{
                    pathname: "/RMDashboard/edit-partner",
                  }}
                  state={{ partnerFirmId: +Id }}
                >
                  <img src={BackArrow} alt="" className="sidebarIcon" />
                  <span
                    className="list-Text"
                    style={{
                      color: "#fec211",
                    }}
                  >
                    Back To Partner Details
                  </span>
                </Link>
              </li>
            </ul>
          )}
          {loggedInRoleType === "PARTNER" && (
            <ul className="list">
              <li className="">
                <Link
                  className="ListItem"
                  to={`/leadManagementDashboard/Dashboard`}
                >
                  <img src={BackArrow} alt="" className="sidebarIcon" />
                  <span
                    className="list-Text"
                    style={{
                      color: "#fec211",
                    }}
                  >
                    Back To Main Menu
                  </span>
                </Link>
              </li>
            </ul>
          )}
        </div>
      </Drawer>
    </div>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    saveDeletBrachIdDetails: (data) => dispatch(saveDeletBrachIdDetails(data)),
    saveDeletTeamsIdDetails: (data) => dispatch(saveDeletTeamsIdDetails(data)),
    getTeamsData: (data) => dispatch(getTeamSideBarDetails(data)),
    getBranchData: (data) => dispatch(getSideBarBranch(data)),
    GetBranchCountDetails: (data) => dispatch(GetBranchCountDetails(data)),
  };
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    access_token: state.auth?.idToken,
    data: state.teamSideBar,
    partnerSidebarDtoList: state.partnerSidebar?.partnerSidebarDtoList,
    userData: state.auth?.userData,
    firmId:
      state.auth?.checkLogin?.partnerFirmId ||
      state?.auth?.loginCredentials?.data?.partnerFirmDetails?.partnerFirmId ||
      sessionStorage.getItem("cetFirmId"),
    userDetail: state.auth?.userData,
    BranchCount: state.BranchCount.branchcount,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PartnerMobileHeader);
